/* cart-drawer.js — Alkaram-style side cart */

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  const body = drawer.querySelector("[data-cart-drawer-body]");
  const footer = drawer.querySelector("[data-cart-drawer-footer]");
  const closeButtons = drawer.querySelectorAll("[data-cart-drawer-close]");

  const open = () => {
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
  };
  const close = () => {
    drawer.hidden = true;
    document.body.style.overflow = "";
  };

  closeButtons.forEach((btn) => btn.addEventListener("click", close));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });

  document.addEventListener("cart:updated", async () => {
    await refreshDrawer();
    open();
  });

  async function refreshDrawer() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || "/"}?sections=cart-drawer`);
      const data = await res.json();
      const html = data["cart-drawer"];
      if (!html) throw new Error("No cart-drawer section");

      const doc = new DOMParser().parseFromString(html, "text/html");
      const newBody = doc.querySelector("[data-cart-drawer-body]");
      const newFooter = doc.querySelector("[data-cart-drawer-footer]");
      const newCount = doc.querySelector("[data-cart-count]");
      const newSubtotal = doc.querySelector("[data-cart-subtotal]");

      if (newBody) body.innerHTML = newBody.innerHTML;
      if (newFooter && footer) {
        footer.innerHTML = newFooter.innerHTML;
        footer.hidden = newFooter.hasAttribute("hidden");
      }
      if (newCount) {
        const countEl = drawer.querySelector("[data-cart-count]");
        if (countEl) countEl.textContent = newCount.textContent;
        updateHeaderCartCount(newCount.textContent);
      }
      if (newSubtotal) {
        drawer.querySelectorAll("[data-cart-subtotal]").forEach((el) => {
          el.textContent = newSubtotal.textContent;
        });
      }
    } catch (err) {
      console.error(err);
      try {
        const cart = await fetch("/cart.js").then((r) => r.json());
        updateHeaderCartCount(String(cart.item_count));
      } catch (e) {
        /* ignore */
      }
    }
  }

  function updateHeaderCartCount(count) {
    const badge = document.getElementById("cartCount");
    if (badge && count !== null && count !== undefined) {
      badge.textContent = count;
      const bubble = badge.closest(".cart-count-bubble");
      if (bubble) bubble.classList.toggle("hidden", Number(count) === 0);
    }
  }

  body.addEventListener("click", async (e) => {
    const line = e.target.closest("[data-cart-line]");
    if (!line) return;
    const key = line.dataset.lineKey;
    const qtyEl = line.querySelector("[data-qty-value]");
    let qty = parseInt(qtyEl?.textContent || "1", 10);

    if (e.target.closest("[data-qty-increase]")) qty += 1;
    else if (e.target.closest("[data-qty-decrease]")) qty = Math.max(0, qty - 1);
    else if (e.target.closest("[data-cart-remove]")) qty = 0;
    else return;

    e.preventDefault();
    line.style.opacity = "0.5";
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    await refreshDrawer();
  });

  window.openCartDrawer = () => refreshDrawer().then(open);
  const cartTrigger =
    document.getElementById("cart-icon-bubble") || document.getElementById("cartCount")?.closest("a");
  cartTrigger?.addEventListener("click", (e) => {
    e.preventDefault();
    window.openCartDrawer();
  });
});
